module.exports = __webpack_public_path__ + "img/tab-login-background.d65e14dc.svg";